exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mdl-mini-footer{display:block;margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/admin/components/Footer.vue
// module id = 259
// module chunks = 0